import { combineReducers } from '@reduxjs/toolkit';
import createKitReducer from './create-kit';
import getKitListReducer from './get-kit-list';
import setKitSubscriptionReducer from './set-kit-subscription';
import transferKitReducer from './transfer-kit';
import updateKitReducer from './update-kit';

const kitReducer = combineReducers({
  createKit: createKitReducer,
  getKitList: getKitListReducer,
  setKitSubscription: setKitSubscriptionReducer,
  transferKit: transferKitReducer,
  updateKit: updateKitReducer
});

export default kitReducer;